import GroupsIcon from '@mui/icons-material/Groups';
import { IconProps } from './iconBase'

/** 受入年齢項目用アイコン */
export const CapacityIcon = (props: IconProps) => {
  return <GroupsIcon {...props} />
}
